import React from 'react'

const AnimalTag = ({country, amount}) => {
    return (
        <div className="animal-tag">
            <div className="animal-tag__body">
                <div className="country">{country}</div>
                <div className="amount">{amount}</div>
            </div>
        </div>
    )
}

export default AnimalTag
